import React, { useState } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Textarea,
} from '@chakra-ui/react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

export function AppInput({
  label,
  helperText,
  type = 'text',
  placeholder,
  value,
  onChange,
  isRequired,
  isInvalid,
  errorMessage,
  maxLength,
  minLength,
  leftAddon,
  ...props
}) {
  const input = (
    <Input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      size="lg"
      fontSize="15px"
      fontWeight="500"
      h="52px"
      maxLength={maxLength}
      minLength={minLength}
      {...props}
    />
  );

  return (
    <FormControl isRequired={isRequired} isInvalid={isInvalid}>
      {label ? <FormLabel>{label}</FormLabel> : null}
      {leftAddon ? (
        <InputGroup size="lg" h="52px">
          <InputLeftAddon
            h="52px"
            fontSize="15px"
            fontWeight="600"
            bg="bg.input"
            borderColor="border.subtle"
            color="text.secondary"
            px={3}
          >
            {leftAddon}
          </InputLeftAddon>
          {input}
        </InputGroup>
      ) : (
        input
      )}
      {isInvalid && errorMessage ? (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      ) : helperText ? (
        <FormHelperText color="text.secondary">{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}

export function AppPasswordInput({
  label,
  helperText,
  placeholder,
  value,
  onChange,
  isRequired,
  isInvalid,
  errorMessage,
  autoComplete,
  ...props
}) {
  const [show, setShow] = useState(false);

  return (
    <FormControl isRequired={isRequired} isInvalid={isInvalid}>
      {label ? <FormLabel>{label}</FormLabel> : null}
      <InputGroup size="lg">
        <Input
          type={show ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          fontSize="15px"
          fontWeight="500"
          h="52px"
          pr="3rem"
          autoComplete={autoComplete}
          {...props}
        />
        <InputRightElement h="52px" w="3rem">
          <IconButton
            aria-label={show ? 'Hide password' : 'Show password'}
            icon={show ? <MdVisibilityOff /> : <MdVisibility />}
            variant="ghost"
            size="sm"
            color="text.secondary"
            onClick={() => setShow((v) => !v)}
            tabIndex={-1}
          />
        </InputRightElement>
      </InputGroup>
      {isInvalid && errorMessage ? (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      ) : helperText ? (
        <FormHelperText color="text.secondary">{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}

export function AppTextarea({
  label,
  helperText,
  placeholder,
  value,
  onChange,
  rows = 4,
  isInvalid,
  errorMessage,
  maxLength,
  isRequired,
  ...props
}) {
  return (
    <FormControl isRequired={isRequired} isInvalid={isInvalid}>
      {label ? <FormLabel>{label}</FormLabel> : null}
      <Textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={rows}
        fontSize="15px"
        maxLength={maxLength}
        {...props}
      />
      {isInvalid && errorMessage ? (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      ) : helperText ? (
        <FormHelperText color="text.secondary">{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
